<template>
  <div>
    <a-form-model layout="inline">
      <a-form-model-item label="机构名称">
        <many-select
          v-model="searchForm.organizationId"
          showSearch
          optionFilterProp="name"
          :options="organizationList"
          :replaceFields="{ label: 'name', value: 'id' }"
          placeholder="请选择机构"
          class="search-item"
          @change="getResourceList"
        >
        </many-select>
      </a-form-model-item>
      <a-form-model-item label="测评名称">
        <a-input placeholder="请输入测评名称" allow-clear :maxLength="20" class="search-item" v-model="searchForm.projectCourseConfigName" />
      </a-form-model-item>
      <a-form-model-item label="资源名称">
        <a-select v-model="searchForm.courseName" allowClear placeholder="请选择资源名称" class="search-item">
          <a-select-option v-for="item in resourceList" :key="item.id" :value="item.name">{{ item.name }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="课时名称">
        <a-input placeholder="请输入课时名称" allow-clear :maxLength="20" class="search-item" v-model="searchForm.courseChildName" />
      </a-form-model-item>
      <a-form-model-item label="课时状态">
        <a-select v-model="searchForm.statuses" allowClear placeholder="请选择课时状态" class="search-item">
          <a-select-option value="0">未开始</a-select-option>
          <a-select-option value="1">进行中</a-select-option>
          <a-select-option value="2">已完成</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="学段">
        <a-select v-model="searchForm.period" allowClear placeholder="请选择学段" class="search-item">
          <a-select-option v-for="item in $data._period" :value="item" :key="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="getPageList(1)" type="primary">查询</a-button>
      </a-form-model-item>
    </a-form-model>

    <a-table
      :columns="courseColumns"
      :scroll="{ y: 300 }"
      style="min-width: 800px"
      row-key="id"
      :row-selection="rowSelection"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="progress" slot-scope="text">
        <a-progress :percent="text.progress" size="small" />
      </div>
      <div slot="complateStatusName" slot-scope="text">
        <span v-if="text.progress === 0">未开始</span>
        <span v-else-if="text.progress === 100" style="color: #52c41a">已完成</span>
        <span v-else style="color: #1890ff">进行中</span>
      </div>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import ManySelect from '@/components/select/ManySelect'

const orgcolumns = [
  { title: '机构名称', scopedSlots: { customRender: 'organizationName' } },
  { title: '学生数', scopedSlots: { customRender: 'student' } },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]
const courseColumns = [
  { title: '机构名称', dataIndex: 'organizationName' },
  { title: '测评名称', dataIndex: 'projectCourseConfigName' },
  { title: '资源名称', dataIndex: 'courseName' },
  { title: '课时名称', dataIndex: 'childCourseName' },
  { title: '学生数', dataIndex: 'studentCount' },
  { title: '课时进度', scopedSlots: { customRender: 'progress' } },
  { title: '状态', scopedSlots: { customRender: 'complateStatusName' } },
  { title: '创建时间', dataIndex: 'createTime' },
]
export default {
  name: 'StepsSecondAddCourse',
  components: { ManySelect },
  props: {
    organizationId: Number,
    single: Boolean, // 是否单选机构
    selectData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      orgcolumns,
      courseColumns,
      organizationList: [],
      resourceList: [],
      searchForm: {
        organizationId: undefined,
        projectCourseConfigName: undefined,
        courseName: undefined,
        courseChildName: undefined,
        statuses: undefined,
      },
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //表格选中项
      selectedRowKeys: [],
      selectedRows: [],
      tableOrgId: undefined,
      reportType: this.$store.getters['organization/getReportInfo'].reportType,
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          if (this.single && !selectedRowKeys.length) {
            this.tableOrgId = undefined
            this.tableRelevant.tableDataSource = [...this.tableRelevant.tableDataSource]
          }

          if (!this.organizationId && this.single && !this.selectedRowKeys.length) {
            this.tableOrgId = selectedRows[0].organizationId
            this.selectedRowKeys = selectedRows.filter((f) => f.organizationId === this.tableOrgId).map((m) => m.id)
            this.tableRelevant.tableDataSource = [...this.tableRelevant.tableDataSource]
          } else {
            this.selectedRowKeys = selectedRowKeys
          }
          this.selectedRows = selectedRows.reduce((pre, cur) => {
            if (!pre.some((s) => s.id === cur.id)) {
              pre.push(cur)
            }
            return pre
          }, [])

          console.log(this.selectedRowKeys, this.selectedRows)
        },
        getCheckboxProps: (record) => {
          let bool = false
          if (this.tableOrgId) {
            bool = record.organizationId !== this.tableOrgId
          }
          if (this.organizationId) {
            bool = record.organizationId !== this.organizationId
          }
          return {
            props: {
              isSelect: this.selectedRowKeys.includes(record.id),
              disabled: bool || this.selectData.some((s) => s.organizationCourseSessionId === record.id) || record.progress <= 0,
            },
          }
        },
      }
    },
  },
  mounted() {
    this.getOrganizationList()
  },
  methods: {
    async getResourceList(organizationId) {
      this.searchForm.courseName = undefined
      if (!organizationId) {
        return (this.resourceList = [])
      }
      const params = {
        CourseType: 1,
        pageIndex: 1,
        pageSize: 9999,
        organizationId: organizationId,
      }
      const { data } = await this.$http.CourseService.getCourseResources(params)
      this.resourceList = data.items
    },
    //获取课时列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        ...this.searchForm,
        isFiltration: true,
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.tableRelevant.tableLoading = true
      this.$http.GroupReport.getCourseChildList(params).then((res) => {
        this.tableRelevant.tableDataSource = res.data.items
        this.tableRelevant.tablePagination.total = res.data.totalCount
        this.tableRelevant.tablePagination.current = res.data.pageIndex
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    // 获取机构列表
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false, orgType: 1 }).then((res) => {
        this.organizationList = res.data.data
        if (res.data.length) {
          this.searchForm.organizationId = res.data[0].id
          this.getPageList(1)
        }
      })
    },
  },
}
</script>

<style scoped>
.search-item {
  width: 180px;
  margin-bottom: 15px;
}
</style>
